export const toggleMobileMenu = () =>({
    type : 'TOGGLE_MOBILE_MENU'
})